export enum ControllerButton {
  VolumeDown = 'VolumeDown',
  VolumeUp = 'VolumeUp',
  Home = 'Home',
  App = 'App',
  Touchpad = 'Touchpad',
}